import {
  TAKING_CAR_PURCHASE_SAVE_BEGIN,
  TAKING_CAR_PURCHACE_BUY_POSSIBLE_ACTIONS_BEGIN,
  TAKING_CAR_PURCHACE_SELL_POSSIBLE_ACTIONS_BEGIN,
  TAKING_CAR_PURCHASE_SAVE_BOTH_BEGIN,
  TAKING_CAR_SALE_UPDATE_COMMENT_BEGIN
} from './constants'
import { saveTakingCarManagmentSaga } from './saveTakingCarManagment/saga';
import { getBuyPossibleActions } from './getBuyPossibleActions/saga';
import { getSellPossibleActions } from './getSellPossibleActions/saga';
import { saveTakingCarManagementBothSaga } from './saveTakingCarManagementBoth/saga';
import { updateCommentSaga } from './updateComment/saga'

import { takeEvery  } from "redux-saga/effects";

// Watchers
export default function* sagas() {
    // Acá van todas las sagas del módulo Gestion Operativa
    yield takeEvery(TAKING_CAR_PURCHASE_SAVE_BEGIN, saveTakingCarManagmentSaga);
    yield takeEvery(TAKING_CAR_PURCHASE_SAVE_BOTH_BEGIN, saveTakingCarManagementBothSaga)
    yield takeEvery(TAKING_CAR_PURCHACE_BUY_POSSIBLE_ACTIONS_BEGIN, getBuyPossibleActions);
    yield takeEvery(TAKING_CAR_PURCHACE_SELL_POSSIBLE_ACTIONS_BEGIN, getSellPossibleActions);
    yield takeEvery(TAKING_CAR_SALE_UPDATE_COMMENT_BEGIN, updateCommentSaga)
}